import { FC, ReactNode } from 'react'
import { Box, Paper, Stack, Typography } from '@mui/material'

interface Props {
  titulo: string
  /** Uma ou duas frases: o que a seção controla e qual o efeito na reserva. */
  descricao?: ReactNode
  /** Botão da seção (ex.: "Novo item"). Nunca quebra em duas linhas. */
  acao?: ReactNode
  /** Rodapé da seção (ex.: "Salvar checklist"), alinhado à direita. */
  rodape?: ReactNode
  children: ReactNode
  'aria-label'?: string
}

/**
 * Seção padrão das abas do produto (08/09): mesmo cartão, mesmo cabeçalho — título,
 * descrição limitada a ~70 caracteres por linha e a ação à direita sem quebrar — e o
 * mesmo rodapé para o botão de salvar. Antes cada bloco da aba Elegibilidade tinha o seu
 * próprio cabeçalho e o "Novo item" quebrava em duas linhas ao lado de uma descrição longa.
 */
export const SecaoProduto: FC<Props> = ({ titulo, descricao, acao, rodape, children, ...rest }) => (
  <Paper variant="outlined" sx={{ p: { xs: 2, md: 3 }, borderRadius: 2 }} component="section" aria-label={rest['aria-label'] ?? titulo}>
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      justifyContent="space-between"
      alignItems={{ xs: 'stretch', sm: 'flex-start' }}
      spacing={2}
      sx={{ mb: 2.5 }}
    >
      <Box sx={{ minWidth: 0, maxWidth: 760 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
          {titulo}
        </Typography>
        {descricao && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {descricao}
          </Typography>
        )}
      </Box>
      {acao && <Box sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}>{acao}</Box>}
    </Stack>
    {children}
    {rodape && (
      <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2.5 }}>
        {rodape}
      </Stack>
    )}
  </Paper>
)

export default SecaoProduto
